import React from "react";

import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Polyline,
} from "@react-google-maps/api";

const TripMap = ({ lastLocation, paths }) => {
  const { REACT_APP_API_KEY_MAPS } = process.env;

  var svg =
    '<svg xmlns="http://www.w3.org/2000/svg" transform="rotate($deg$)" viewBox="0 0 64.83 25.19"> <defs> <style> .a8e03696-c197-4398-9010-7374f8c446e6 { fill: #3a3a3a; }  .ca7a4bd6-ebdf-476d-8599-3d839b197643 { fill: #252525; }  .cb48c74-9882-4cc3-bf11-6c4a7a3a1e36 { fill: #fff; }  .c20d69d5-26d9-4f9b-bc56-081fb17d8364 { fill: #3c3c3c; }  .w22376a7-0fe6-4479-9ccd-d17b1f9b4625 { fill: #e2e4dd; }  .c66a22b-b2f0-49b5-82e7-41d355580293 { fill: #ff9a0b; }  .e60d809-cdc3-4a2e-bb70-51095c62e0f0 { fill: #3d3d3d; }  .e4b0d17f-7bd1-4815-9bf6-064e9a371453 { fill: #787878; } </style> </defs> <title>Recurso 1</title> <g id="6207813f-91f6-46b0-8ee5-a58e3e86296b" data-name="Capa 2"> <g id="64258c4e-b7a2-4d89-89df-142de5e16bf3" data-name="Layer 1"> <rect class="a8e03696-c197-4398-9010-7374f8c446e6" x="40.05" y="5.41" width="7.37" height="14.37" /> <path class="ca7a4bd6-ebdf-476d-8599-3d839b197643" d="M64.16,19.91c.9-2.35.9-12.28,0-14.63-.62-1.64-.87-3.06-1.67-3.06H61c-.16.39.53.4.85.81a10,10,0,0,1,.82,2.25c.9,2.35.9,12.28,0,14.63a9.7,9.7,0,0,1-.82,2.24c-.32.42-1,.43-.85.82h1.48C63.29,23,63.54,21.55,64.16,19.91Z" /> <path class="cb48c74-9882-4cc3-bf11-6c4a7a3a1e36" d="M46,22.74H61.1c.78,0,1.23-1.25,1.84-2.87.88-2.34.88-12.21,0-14.55-.61-1.62-1.06-2.88-1.84-2.88H46Z" /> <path class="c20d69d5-26d9-4f9b-bc56-081fb17d8364" d="M54.69,8.54a20.16,20.16,0,0,1,.41,4h0v.07h0a20.16,20.16,0,0,1-.41,4,19,19,0,0,1-.84,2.92c1.62.76,3.71,1.71,3.71,1.71a12.67,12.67,0,0,0,1.69-4.57,20,20,0,0,0,.42-4.08h0s0,0,0,0v0h0a20,20,0,0,0-.42-4.08,12.6,12.6,0,0,0-1.69-4.57s-2.09,1-3.71,1.71A19,19,0,0,1,54.69,8.54Z" /> <polygon class="c20d69d5-26d9-4f9b-bc56-081fb17d8364" points="56.74 21.78 52.88 19.78 47.42 19.78 47.42 21.82 56.74 21.78" /> <polygon class="c20d69d5-26d9-4f9b-bc56-081fb17d8364" points="56.74 3.4 52.88 5.41 47.42 5.41 47.42 3.37 56.74 3.4" /> <path class="w22376a7-0fe6-4479-9ccd-d17b1f9b4625" d="M62.94,19.87a10.81,10.81,0,0,0,.44-2.36,1.75,1.75,0,0,0-.75.23c-.62.41-1.46,3.16-.3,3.66C62.53,21,62.73,20.44,62.94,19.87Z" /> <path class="w22376a7-0fe6-4479-9ccd-d17b1f9b4625" d="M62.94,5.32c-.21-.57-.41-1.09-.61-1.53-1.16.5-.32,3.25.3,3.66a1.9,1.9,0,0,0,.75.23A10.81,10.81,0,0,0,62.94,5.32Z" /> <path class="c66a22b-b2f0-49b5-82e7-41d355580293" d="M62.72,20.45l-1-.24A21.3,21.3,0,0,0,61,22.74h.11a.86.86,0,0,0,.4-.13A4.78,4.78,0,0,0,62.72,20.45Z" /> <path class="c66a22b-b2f0-49b5-82e7-41d355580293" d="M62.72,4.74A4.78,4.78,0,0,0,61.5,2.58a.88.88,0,0,0-.4-.14H61A21.11,21.11,0,0,0,61.72,5Z" /> <path class="cb48c74-9882-4cc3-bf11-6c4a7a3a1e36" d="M55.5,21.82l0,3.37s.28,0,.67-.4a7.92,7.92,0,0,0,.54-3Z" /> <path class="cb48c74-9882-4cc3-bf11-6c4a7a3a1e36" d="M55.5,3.37l0-3.37s.28,0,.67.4a7.92,7.92,0,0,1,.54,3Z" /> <rect class="e60d809-cdc3-4a2e-bb70-51095c62e0f0" y="1.11" width="43.21" height="22.98" /> <rect class="e60d809-cdc3-4a2e-bb70-51095c62e0f0" x="4.25" y="3.37" width="34.71" height="18.46" /> <rect class="e4b0d17f-7bd1-4815-9bf6-064e9a371453" x="4.25" y="5.14" width="34.71" height="14.91" /> <rect class="e60d809-cdc3-4a2e-bb70-51095c62e0f0" x="4.25" y="6.95" width="34.71" height="11.28" /> <rect class="e4b0d17f-7bd1-4815-9bf6-064e9a371453" x="4.25" y="8.71" width="34.71" height="7.76" /> <rect class="e60d809-cdc3-4a2e-bb70-51095c62e0f0" x="4.25" y="10.34" width="34.71" height="4.5" /> <rect class="e4b0d17f-7bd1-4815-9bf6-064e9a371453" x="4.25" y="11.77" width="34.71" height="1.65" /> <rect class="e60d809-cdc3-4a2e-bb70-51095c62e0f0" x="2.17" y="3.37" width="0.93" height="18.44" /> <rect class="e60d809-cdc3-4a2e-bb70-51095c62e0f0" x="40.05" y="3.37" width="0.93" height="18.44" /> </g> </g> </svg>';

  const [zoom, setZoom] = React.useState(5);
  const [center, setCenter] = React.useState({
    lat: 18.1932342,
    lng: -101.9061163,
  });

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: REACT_APP_API_KEY_MAPS,
  });

  React.useEffect(() => {
    if (lastLocation) {
      setZoom(11);
      setCenter(lastLocation);
    }
  }, [lastLocation]);

  return isLoaded ? (
    <>
      <GoogleMap
        mapContainerClassName="w-full h-full"
        zoom={zoom}
        center={center}
        options={{
          fullscreenControl: false,
          mapTypeControl: false,
          streetViewControl: false,
        }}
      >
        {lastLocation ? (
          <Marker
            position={lastLocation}
            icon={{
              url:
                "data:image/svg+xml;charset=utf-8," +
                encodeURIComponent(svg.replace("$deg$", 90)),
              fillColor: "#21282e",
              fillOpacity: 1,
              strokeWeight: 0,
              scaledSize: new window.google.maps.Size(50, 50),
              anchor: new window.google.maps.Point(20, 20),
              scale: 1.5,
            }}
            key={`marker_`}
          />
        ) : null}

        {paths && paths.length > 0 ? (
          <Polyline
            path={paths}
            options={{ fillColor: "#21282e", strokeWeight: 2 }}
            key="path"
          />
        ) : null}
      </GoogleMap>
    </>
  ) : (
    <></>
  );
};

export default TripMap;
